<template src='./phase-forms.html'></template>

<script>
import Vue from 'vue'
import { EventBus } from '@/router/bus'
import { authorizedOrganizationId } from '@/router/auth'
import VueMarkdown from 'vue-markdown'
import Prism from 'prismjs'
import 'prismjs/components/prism-go.min'
import _ from 'lodash'

export default {
  components: {
    VueMarkdown
  },
  props: ['selectedPhase', 'project'],
  data () {
    return {
      projectCode: this.$route.params.projectCode,
      projectPhaseId: this.$route.params.projectPhaseId,
      phaseFormId: this.$route.params.phaseFormId,
      validationDialog: false,
      validationData: [],
      tab: null,
      // projectPhases: {
      //   PREIMPLEMENTATION: 0,
      //   IDENTIFICATION: 1,
      //   PLAN: 2,
      //   REPORTING: 3,
      //   RATIONALIZATION: 4,
      //   CONCLUSION: 5,
      //   EFFECTS: 6
      // },
      projectPhases: {
        IDEA: 0,
        PROJECTIDENTIFICATION: 1,
        PREPAREDNESS: 2,
        IMPORTANT: 3,
        PLAN: 4,
        REPORTING: 5,
        RATIONALIZATION: 6,
        CONCLUSION: 7,
        EFFECTS: 8,
        PREIMPLEMENTATION: 9,
        IDENTIFICATION: 10
      },
      formStatus: {
        UNLOCKED: 1,
        LOCKED: 2,
        MARKED: 3,
        APPROVED: 4
      }
    }
  },
  computed: {
    getColor () {
      return this.project.phase === this.selectedPhase.phase ? 'var(--v-cards-base)' : 'var(--v-success-light-base)'
    },
    displayFormDetails () {
      return Vue.$config.administration_organization_id === authorizedOrganizationId()
    },
    orderedForms () {
      return _.orderBy(this.selectedPhase.forms, 'id', 'desc')
    },
    formSummary () {
      const selectedPhase = this.selectedPhase.phase
      return selectedPhase < 3 ? {
        name: this.$t(`form.name.${selectedPhase}`),
        description: this.$t(`form.description.${selectedPhase}`)
      } : ''
    }
  },
  mounted () {
    EventBus.$emit('reload-crumbs')
  },
  methods: {
    highlight () {
      this.$nextTick(() => {
        Prism.highlightAll()
      })
    },
    formatFormData (data) {
      if (this.selectedPhase.phase === this.projectPhases.REPORTING) {
        if (data) {
          let parsedData = JSON.parse(data)
          if (parsedData.SuccessKeyIndicator) {
            parsedData = parsedData.SuccessKeyIndicator
          }
          return {
            inactivity: parsedData.Inactivity ? parsedData.Inactivity.Value ? this.$t('form.no') : this.$t('form.yes') : '',
            inactivityLimit: parsedData.Inactivity ? !parsedData.Inactivity.Value : '',
            fundingAdequacyIndicator: parsedData.FundingAdequacyIndicator ? this.formatAmount(parsedData.FundingAdequacyIndicator.Value) : '',
            fundingAdequacyIndicatorLimit: parsedData.FundingAdequacyIndicator ? parsedData.FundingAdequacyIndicator.LimitReached : '',
            timeToProjectImplementation: parsedData.TimeToProjectImplementation ? this.formatAmount(parsedData.TimeToProjectImplementation.Value, 1) : '',
            timeToProjectImplementationLimit: parsedData.TimeToProjectImplementation ? parsedData.TimeToProjectImplementation.LimitReached : '',
            selectedAppropriations: parsedData.FundingAdequacyIndicator ? parsedData.FundingAdequacyIndicator.AppropriationAmount ? parsedData.FundingAdequacyIndicator.AppropriationAmount > 0 : false : false
          }
        }
      }
      return ''
    },
    warningsCount (form) {
      const warnings = JSON.parse(form.lastRevisionWarnings)
      const missingAppropriationWarning = this.formatFormData(form.data) === '' || this.formatFormData(form.data).selectedAppropriations ? 0 : 1
      return (warnings ? warnings.length : 0) + missingAppropriationWarning
    },
    openWarningsDialog (form) {
      const warnings = this.formatWarnings(form)
      this.validationData = warnings
      this.validationDialog = true
    },
    formatWarnings (form) {
      const warnings = JSON.parse(form.lastRevisionWarnings)
      const data = this.formatFormData(form.data)
      if (data && !data.selectedAppropriations) {
        const notSelectedAppropriations = { Index: 0, StatusCode: { Code: 'FluentEmptyProjectFormAppropriations' } }
        warnings.unshift(notSelectedAppropriations)
      }
      return warnings
    },
    gotoPIF (phaseFormId, code) {
      this.phaseFormId = phaseFormId
      this.$router.push('/projects/' + this.projectCode + '/phases/' + Number(this.selectedPhase.id) + '/forms/' + code + '/id/' + Number(phaseFormId))
    },
    gotoPIFnewTab (phaseFormId, code) {
      const href = `/projects/${this.projectCode}/phases/${Number(this.selectedPhase.id)}/forms/${code}/id/${Number(phaseFormId)}`
      window.open(href, '_blank')
    }
  }
}
</script>

<style>
.v-chip {
  font-weight: 600 !important;
  /* font-size: 20px !important */
}
.item-container {
  font-weight: 600 !important;
  font-size: 15px !important;
}

.drop-menu-item {
  margin: 0 0 0 50px;
}
.claim-item {
  font-size: 15px;
  font-weight: 300;
  line-height: 1;
  letter-spacing: 0.02em;
  font-family: 'Source Sans Pro', sans-serif;
  margin-left: 30px;
}

.centered-label {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.list-container {
  height: 264px;
  overflow-y: auto;
  font-size: 11pt;
  border: 1px solid rgba(0, 0, 0, .12);
}
.clickable-list {
  cursor: pointer;
}
.dense-list {
  min-height: 22px !important;
}
.extra-small {
  width: 24px !important;
  height: 24px !important;
}
</style>
